import _ from 'lodash';
import useSWR from 'swr';
import { getPortalsByAccount, type PortalShort } from '../services/portal';
import { useBoards } from '../shared/hooks/use-boards';

// @ts-ignore
const clientPortalUrlPattern = import.meta.env.VITE_APP_CLIENT_PORTAL_URL;

function getPortalUrl(portal: PortalShort): string {
  if (portal.customDomain) {
    return `https://${portal.customDomain}`;
  }
  return clientPortalUrlPattern.replace('-PORTALID-', portal.portalId);
}

export function usePortals() {
  const {
    data: portals,
    isLoading: arePortalsLoading,
    error: portalsError,
  } = useSWR(
    '/portals',
    async () => {
      return await getPortalsByAccount();
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
    },
  );

  const { boards, isLoading } = useBoards(
    portals ? portals.filter((portal) => portal.boardId).map((portal) => +portal.boardId!) : [],
    false,
  );
  const boardsById = _.keyBy(boards || [], 'id');

  const portalsWithBoardInfo = (portals || [])
    .filter((portal) => portal.boardId && boardsById[portal.boardId])
    .map((portal) => {
      return {
        ...portal,
        board: boardsById[portal.boardId!],
      };
    });

  // For admin view - include all portals with computed fields
  const allPortalsWithInfo = (portals || []).map((portal) => {
    const board = portal.boardId ? boardsById[portal.boardId] : null;
    return {
      ...portal,
      board: board || null,
      boardName: board?.name || null,
      isPublished: !!portal.lastPublishedAt,
      portalUrl: getPortalUrl(portal),
      portalId: portal.portalId,
    };
  });

  return {
    portals,
    arePortalsLoading: arePortalsLoading || isLoading,
    portalsError,
    boards,
    portalsWithBoardInfo,
    allPortalsWithInfo,
  };
}
